import {combineReducers} from '@reduxjs/toolkit';

import {activePlatformAlertsStateSlice} from './all-alerts/slices/active-platform-alerts-state.slice';
import {activePlatformAlertsSlice} from './all-alerts/slices/active-platform-alerts.slice';

export const platformAlertBuilderReducer = combineReducers({
    result: activePlatformAlertsSlice.reducer,
    state: activePlatformAlertsStateSlice.reducer,
});
